import script from "./MyAssetActionsMixin.vue?vue&type=script&lang=js"
export * from "./MyAssetActionsMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__